/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Button, Modal } from 'semantic-ui-react';

const CommonModal = ({ data, id }) => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
  };
  return (
    <div>
      <Modal onClose={onClose} open size={data.size} closeOnDimmerClick={false}>
        <Modal.Header>{data.title}</Modal.Header>
        <Modal.Content>{data.content}</Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
              if (data.onClose) data.onClose();
            }}>
            {data.closeText ?? 'Close'}
          </Button>
          {data.okButton && data.okButton}
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default CommonModal;
